<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                    <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="filters.dateFrom"
                                    label="Od"
                                    prepend-icon="mdi-calendar-blank"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.dateFrom"
                            :first-day-of-week="1"
                            @input="menu1 = false"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div>
                    <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="filters.dateTo"
                                    label="Do"
                                    prepend-icon="mdi-calendar-blank"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.dateTo"
                            :first-day-of-week="1"
                            @input="menu2 = false"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div>
                    <v-menu
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="companyNameFilter"
                                    label="Nazwa firmy"
                                    prepend-icon="mdi-magnify"
                                    :counter="100"
                                    :rules="rules.companyNameFilter"
                                    v-bind="attrs"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                    </v-menu>
                </div>
                <div>
                    <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-select
                                :items="supervisors"
                                v-model="filters.supervisor"
                                label="Opiekun"
                                item-value="id"
                                solo
                                v-bind="attrs"
                                v-on="on"
                                class="wastemaster-input-elevation"
                            >
                                <template v-slot:selection="data">
                                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                                <template v-slot:item="data">
                                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                            </v-select>
                        </template>
                    </v-menu>
                </div>
                <div>
                    <v-chip-group v-model="filters.status" column active-class="primary--text">
                        <v-chip v-for="(key, status) in statuses" :key="status" :value="status">
                            {{ getStatusText(status) }}
                        </v-chip>
                    </v-chip-group>
                </div>
                <v-switch v-model="filters.wmAssistantStatus" label="Wymaga pomocy asystenta" />
                <v-switch v-model="filters.wmFinancing" label="Sprzedaj z WasteMaster" />
                <v-switch v-model="filters.handedOverToPartner" label="Przekazana do Partnera" />
                <v-btn
                  @click="onAddOfferTriggered"
                >
                    Dodaj ofertę
                </v-btn>
            </v-col>
            <v-col cols="10">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="offers"
                        :options.sync="options"
                        :server-items-length="totalOffers"
                        :loading="loading"
                        :item-class="wmFinancingRow"
                        class="elevation-1 row-pointer"
                        @click:row="(saleOffer) => $router.push({name: 'sale-offer-details', params: { id: saleOffer.id }}).catch(()=>{})"
                >
                    <template v-slot:item.status="{ item }">
                        {{ getStatusText(item.status) }}
                      </template>
                    <template v-slot:item.supervisor="{ item }">
                          <span v-if="item.supervisor" :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                            {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                          </span>
                      <span v-else>
                            -
                          </span>
                    </template>
                    <template v-slot:item.buyProposals="{ item }">
                        {{ item.buyProposals.total }}
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                        {{ localDateTime(item.createdAtDto) }}
                    </template>
                    <template v-slot:item.company.name="{ item }">
                        <div>{{ item.company.name }}</div>
                      <div
                          v-if="item.wmFinancing"
                      >
                        <strong>Posiada ofertę z WM</strong>
                      </div>
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import debounce from 'debounce';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
    import {SaleOfferStatus, getStatusText} from '@/enums/SaleOfferStatus';
    import moment from 'moment';
    import {SaleOfferWmAssistantStatus} from '@/enums/SaleOfferWmAssistantStatus';
    import permissions from '@/mixins/permissions';

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                statuses: SaleOfferStatus,
                modal: false,
                menu1: false,
                menu2: false,
                menu3: false,
                filters: {
                    dateFrom: this.getDateFrom().format('YYYY-MM-DD'),
                    dateTo: moment().format('YYYY-MM-DD'),
                    status: null,
                    wmAssistantStatus: null,
                    wmFinancing: false,
                    handedOverToPartner: false,
                    supervisor: null,
                },
                companyNameFilter: '',
                supervisorFilter: null,
                totalOffers: 0,
                offers: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'Opiekun', value: 'supervisor', sortable: false },
                    { text: 'Kategoria', value: 'categoryName', sortable: false },
                    { text: 'Firma', sortable: false, value: 'company.name' },
                    { text: 'Ilość', value: 'quantity', sortable: false, },
                    { text: 'Status', value: 'status', sortable: false, },
                    { text: 'Miasto', value: 'city', sortable: false, },
                    { text: 'Kod pocztowy', value: 'postalCode', sortable: false, },
                    { text: 'Wyświetleń', value: 'viewCount', sortable: false, },
                    { text: 'Oferty kupna', value: 'buyProposals', sortable: false, },
                    { text: 'Utworzono', value: 'createdAt', sortable: false },
                ],
                rules: {
                    companyNameFilter: [
                        (value) => {
                            if (!value) {
                                return true;
                            }

                            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
                        },
                    ],
                },
                reactOnFilterChange: true,
                supervisors: [],
            }
        },
        watch: {
            options: {
                handler () {
                    this.getOffers();
                    setDatatableOptions.call(this);
                },
                deep: true,
            },
            filters: {
                handler() {
                    if (!this.reactOnFilterChange) {
                        return;
                    }

                    setDatatableFilters.call(this);
                    this.getOffers();
                },
                deep: true
            },
            companyNameFilter() {
                this.getOffersFilteredByCompanyName();
            },
        },
        methods: {
            getDateFrom() {
                if (this.isAdmin()) {
                    return moment().clone().subtract(3, 'months');
                }

                return moment().clone().subtract(2, 'weeks');
            },
            async getSupervisors() {
              this.loading = true;

              const response = await api.get('/api/users?role=ROLE_SUPERVISOR', {});
              this.loading = false;

              this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(response.data.items);
            },
            async getOffers() {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                if (this.filters.dateFrom) {
                    const dateFromString = String(this.filters.dateFrom).substr(0, 10);
                    this.reactOnFilterChange = false;

                    if (!moment(dateFromString).isValid()) {
                      this.filters.dateFrom = this.getDateFrom();
                    } else {
                      this.filters.dateFrom = dateFromString;
                    }

                    this.reactOnFilterChange = true;
                }

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0,
                    ...this.filters
                };

                if (this.companyNameFilter && this.companyNameFilter.length > 1) {
                    params.companyName = this.companyNameFilter;
                } else {
                    delete params.companyName;
                }

                if (this.supervisorFilter) {
                    params.supervisor = this.supervisorFilter;
                } else {
                    delete params.supervisorFilter;
                }

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (!params.status) {
                    delete params.status;
                }

                if (params.wmAssistantStatus) {
                    params.wmAssistantStatus = SaleOfferWmAssistantStatus.RA.description;
                } else {
                    delete params.wmAssistantStatus;
                }

                const response = await api.get('/api/sale-offers', {params});
                this.loading = false;

                this.offers = response.data.items;
                this.totalOffers = response.data.total;
                this.reactOnFilterChange = false;
                this.filters.dateFrom = response.data.dateFrom;
                setTimeout(() => {
                    this.reactOnFilterChange = true;
                }, 100); // Delay the change a bit to avoid performing another query.
            },
            getStatusText(status) {
                return getStatusText(status);
            },
            onAddOfferTriggered() {
              this.$router
                  .push({name: 'sale-offer-add'})
                  .catch(() => {});
            },
            wmFinancingRow(item) {
              return item.wmFinancing ? 'wmFinancingRow' : '';
            }
        },
        created() {
            this.getSupervisors();
            getDatatableParams.call(this);
            this.getOffersFilteredByCompanyName = debounce(function () {
                this.getOffers();
            }, 500);
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> td {
        height: auto !important;
        padding: 0.5rem !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .row-pointer >>> tbody .wmFinancingRow,
    .row-pointer >>> tbody .wmFinancingRow:hover {
      background: #929292;
    }
</style>